import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import uid from 'uid';
import Lightbox from 'react-image-lightbox';
import ReactTooltip from "react-tooltip";
import Notice from "../Notification/newNotification";
import 'react-image-lightbox/style.css';
import {sortImagesByStatus} from "../../helpers";
import {getExtensionFromMimeType} from "../../utils/utils"
import PDFImage from './pdf.svg';

import {
    IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD,
    IMAGE_UPLOAD_STATUS_UPLOADING,
    IMAGE_UPLOAD_STATUS_FAILED,
    IMAGE_UPLOAD_STATUS_UPLOADED,
} from "../../shared/redux/constants"

// Actions

import {setImageData, removeImageData, removeSeveralUploadedImages} from "../../shared/redux/actions"

const MAX_IMAGE_SIZE = 50 * 1024 * 1024;

class Images extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            openImageIndex: 0,
            isOpenImage: false,

        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps (nextProps,prevState) {
        if (nextProps.uploadsCompleted) {
            const { uploadedImages, uploadedKeys } =
                Object.entries(nextProps.uploads)
                    .filter(([_, { status , filename }]) => {
                        return status === IMAGE_UPLOAD_STATUS_UPLOADED && (!this.props.images.length || this.props.images.some((image) => image.filename !== filename))
                    })
                    .reduce((acc, [key, {filename, imageSrc}]) => {
                        acc.uploadedImages.push({filename, imageSrc});
                        acc.uploadedKeys.push(key);
                        return acc;
                    }, { uploadedImages: [], uploadedKeys: [] });
            if (uploadedImages.length) {
                this.props.removeSeveralUploadedData(uploadedKeys);
                this.props.handleChange('image', {...this.state, currentImage: uploadedImages},false);
            }
        }
    }

    handleChange(event) {
        event.preventDefault();
        const allowedMimes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'image/svg+xml', 'video/webm'];
        const value = event.target;

        const processImage = (file) => {
            if (allowedMimes.indexOf(file.type) === -1) {
                Notice.addNotification(`The image ${file.name} uploaded format is not supported. Please upload an image in .jpg or .png formats.`, 'error');
                return Promise.resolve(null);
            }
            if (file.size > MAX_IMAGE_SIZE) {
                Notice.addNotification(`Image ${file.name} should not be larger than 51Mb`, 'error');
                return Promise.resolve(null);
            }
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = (e) => {
                    if (e.target.result) {
                        const filename = `${uid()}${getExtensionFromMimeType(file.type)}`;
                        resolve({
                            filename,
                            binary: file,
                            contentType: file.type,
                            imageSrc: e.target.result,
                            status: IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD
                        });
                    }
                };
                reader.readAsDataURL(file);
            });
        };

        Promise.allSettled(Object.values(value.files).map(processImage))
            .then(results => {
                if (this.props.onImageChange) {
                    this.props.onImageChange();
                }
                const validImages = results.reduce((acc, result) => {
                    if (result.status === 'fulfilled' && result.value) {
                        acc[result.value.filename] = result.value;
                    }
                    return acc;
                }, {});
                this.props.setImageData(validImages);
            })
            .catch(error => {
                console.error(error);
            });
    }

    handleRemoveImage = (fileName) => {
        if (!this.props.disableEdit) {

            if ((fileName in this.props.uploads || fileName in this.props.achievedUploads) && this.props.onImageChange) {
                this.props.onImageChange();
            }

            if (fileName in this.props.uploads) {
                this.props.removeImageData(fileName);
            } else {
                this.props.removeImage(fileName)
            }
        }
        if (this.upload) {
            this.upload.value = '';
        }
    }

    handlePDFClick = (pdfUrl,fileName) => {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = "_blank"
        link.download = fileName;
        link.click();
    }

    openImage(index) {
        this.setState({isOpenImage: true, openImageIndex: index});
    }

    renderImage = (image, index, className = "", style = {}) => {
        return (
            <div className={className} key={index} style={style}>
                                    <span
                                        onClick={() => this.handleRemoveImage(image.filename)}
                                        className='kr kr-close close'
                                    />
                <img
                    alt=''
                    key={index}
                    src={image.isPDF ? PDFImage : image.imageSrc}
                    onClick={() => image.isPDF ? this.handlePDFClick(image.imageSrc, image.filename) : this.openImage(index)}
                    className={this.props.isBookingForm ? "image-upload-form" : "image-upload-section"}
                />
                {(() => {

                    switch (image.status) {
                        case IMAGE_UPLOAD_STATUS_UPLOADING : {
                            return <progress value={image.progress} max="100">{image.progress}%</progress>
                        }
                        case IMAGE_UPLOAD_STATUS_UPLOADED : {
                            return (
                                <div className="upload-success">Uploaded</div>
                            )
                        }
                        case IMAGE_UPLOAD_STATUS_FAILED: {
                            return (
                                <Fragment>
                                    <div className="upload-failed">Upload Failed</div>
                                    {image.error ? <p className="upload-error">{image.error}</p> : null}
                                </Fragment>
                            )
                        }
                        case IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD : {
                            return (
                                <Fragment>
                                    <div
                                        className="kr kr-edit upload-waiting"
                                        data-for="upload-waiting"
                                        data-tip="You must SAVE for your pictures to be uploaded">
                                        Waiting
                                    <ReactTooltip place="right" id="upload-waiting" type="light" effect="float"/>
                                    </div>
                                </Fragment>
                            )
                        }
                        default: {
                            return null;
                        }
                    }
                })()}
            </div>
        )
    }

    render() {
        const {openImageIndex} = this.state;
        const { pdfs, filteredImages } = [...this.props.images,...Object.values(this.props.uploads)].reduce((acc, file) => {
            const filename = file.filename;
            const status = filename in this.props.achievedUploads ? this.props.achievedUploads[filename].status : undefined;

            if (file.filename && file.filename.endsWith('.pdf')) {
                acc.pdfs.push({
                    isPDF: true,
                    ...file,
                    ...(status && { status })
                });
            } else {
                acc.filteredImages.push({ ...file,   ...(status && { status }) });
            }
            return acc;
        }, { pdfs: [], filteredImages: [] });


        const imagesToOpen = filteredImages.sort(sortImagesByStatus);
        const imagesList = [...imagesToOpen,...pdfs].sort(sortImagesByStatus);
        return (
            <div className={`upload-block ${this.props.className ? this.props.className : ''}`}>
                {this.props.isForm ?
                    <div className="image-block test-icon-image">
                        <div className="middle row">
                            {imagesList.length > 0 && imagesList.slice(0, 3).map((image, index) => this.renderImage(image, index, "mr-4", {maxWidth: "28%"}))}
                            {imagesList.length > 0 && this.props.showMore && imagesList.map((image, index) => this.renderImage(image, index, "mr-4", {maxWidth: "28%"}))}
                        </div>
                        {
                            imagesList.length > 0 && imagesList.length > 3 && this.props.isBookingForm &&
                            <div className="more">And {this.props.images.length - 3} more</div>
                        }
                        {
                            imagesList.length > 0 && imagesList.length > 3 && !this.props.isBookingForm &&
                            <button type='button' className="btn btn-link btn-sm float-right"
                                    onClick={() => this.props.handleSeeMore()}>See more...</button>
                        }
                    </div>
                    :
                    <div className="image-block test-icon-image uploaded">
                        <div className="middle">
                            {!imagesList.length && <div className="no-images"> No photos are found for this case</div>}
                            {imagesList.map((image, i) => this.renderImage(image, i, "img"))}
                        </div>
                    </div>
                }
                <div className="upload-actions mobile-version">
                    {this.props.hasErrorImages ? this.upload.value = '' : false}
                    <label htmlFor="file-upload"
                           className={`btn btn-primary add-file ${this.props.buttonDisabled ? 'disabled_date' : ''}`}>Add
                        File</label>
                    <input className="upload-form" disabled={this.props.buttonDisabled} id="file-upload"
                           ref={i => this.upload = i} onChange={(e) => {
                        this.handleChange(e)
                    }} type="file" multiple/>
                    {!this.props.isForm && <button disabled={this.props.buttonDisabled} className=" btn btn-secondary"
                                                   onClick={(event) => this.props.handleSaveBooking(event)}>Save
                        Photos</button>}
                </div>
                <div className="upload-actions desktop-version">
                    {this.props.hasErrorImages ? this.upload.value = '' : false}
                    <label htmlFor="file-upload"
                           className={`desktop-add-file ${this.props.buttonDisabled ? 'disabled_date' : ''}`}>
                        <p>
                            <span className="kr kr-upload"/>
                            Drag & Drop Files Here or
                        </p>
                        <span>Browse</span>
                        <p className="kr kr-upload-info">
                            JPEG, JPG, PNG, PDF, SVG, WebM. Max file size: 51 MB.
                        </p>
                    </label>
                    <input className="upload-form" disabled={this.props.buttonDisabled} id="file-upload"
                           ref={i => this.upload = i} onChange={(e) => this.handleChange(e)} type="file" multiple/>
                    {!this.props.isForm && <button disabled={this.props.buttonDisabled} className=" btn btn-secondary"
                                                   onClick={(event) => this.props.handleSaveBooking(event)}>Save
                        Photos</button>}
                </div>
                {this.state.isOpenImage && imagesToOpen.length && (
                    <Lightbox
                        mainSrc={imagesToOpen[openImageIndex].imageSrc}
                        nextSrc={imagesToOpen.length === 1 ? undefined : imagesToOpen[(openImageIndex + 1) % imagesToOpen.length].imageSrc}
                        prevSrc={imagesToOpen.length === 1 ? undefined : imagesToOpen[(openImageIndex + imagesToOpen.length - 1) % imagesToOpen.length].imageSrc}
                        onCloseRequest={() => this.setState({isOpenImage: false})}
                        onMovePrevRequest={() =>
                            this.setState({
                                openImageIndex: (openImageIndex + imagesToOpen.length - 1) % imagesToOpen.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                openImageIndex: (openImageIndex + 1) % imagesToOpen.length,
                            })
                        }
                    />
                )}

            </div>
        )
    }
}

const mapStateToProps = ({imageUploadReducer}) => {
    return {
        uploadImagesStarted: imageUploadReducer.uploadImagesStarted,
        uploads: imageUploadReducer.uploads,
        uploadsCompleted: imageUploadReducer.uploadingComplete,
        achievedUploads: imageUploadReducer.achievedUploads
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setImageData: (images) => dispatch(setImageData(images)),
        removeImageData: (fileName) => dispatch(removeImageData(fileName)),
        removeSeveralUploadedData: (images) => dispatch(removeSeveralUploadedImages(images))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Images);


// WEBPACK FOOTER //
// ./src/components/Images/Images.js